var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 23",
    "aria-labelledby": "downloadIcon downloadDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M19.523 20.258l-1.061 1.062v-1.062h1.061zm-10.3-6.747V0h2.123v13.528l4.634-4.935 1.548 1.453-7.236 7.705-7.235-7.705 1.548-1.453 4.618 4.918zm9.239 1.347h2.123v7.523H0v-7.523h2.123v5.4h16.339v-5.4z"
  })));
}

export default SvgDownload;